import { createNotImplementedMethod } from '../utils';
var NotImplementedIngredientRepository = /** @class */ (function () {
    function NotImplementedIngredientRepository() {
        this.getIngredients = createNotImplementedMethod();
    }
    return NotImplementedIngredientRepository;
}());
export { NotImplementedIngredientRepository };
